import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import { SettingsBreadcrumbs } from '../settingsModule';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import React from 'react';
import AuthenticationLink from './AuthenticationLink';
import {
  CalendarConfiguration,
  EVENT_CONFIGURATION_DELETED, EventConfigurationErrorCode,
  useEventsConfigurationService
} from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import { NewLine, Text, TextLink } from 'ui-builder';
import { ErrorMessage, TextDeleteLink } from 'features/nekst-widgets';
import { ToggledFeature, ToggleWrapper } from 'feature-toggle';

import styles from './CalendarIntegrationPage.module.scss';

function CalendarConfigurationWidget(props: {
  configuration: CalendarConfiguration,
}) {
  const eventConfigurationService = useEventsConfigurationService();

  return (
    <>
      <Text>
        Nekst is linked to:
        {' '}
        <Text bold>{props.configuration.email}</Text>
        . To unlink your Calendar from this account, please click below.
        <NewLine />
        <NewLine />
        <TextDeleteLink
          deleteFunc={eventConfigurationService.deleteTokens}
          deleteMessage="Are you sure you want to unlink your Google account? You'll not able to create appointment tasks then."
        >
          Unlink Account
        </TextDeleteLink>
      </Text>
      <NewLine />
    </>

  );
}

function ErrorCodeMessage(props: {
  code: EventConfigurationErrorCode,
}) {
  if (props.code === EventConfigurationErrorCode.REQUIRED_SCOPE_NOT_GRANTED) {
    return (
      <ErrorMessage>
        Access to your Google Calendar was not granted. Please try again by checking your permissions and ensuring the request is approved.
      </ErrorMessage>
    );
  } else if (props.code === EventConfigurationErrorCode.INVALID_CODE) {
    return (
      <ErrorMessage>
        The connection to your Google account is invalid. This may happen if an incorrect code was provided. Please try again.
      </ErrorMessage>
    );
  } else {
    return null;
  }
}

function PolicyLink() {
  return (
    <>
      <NewLine />
      <Text className={styles.text}>
        Refer to the 'Google Integrations (Calendar & Gmail)' section in our
        {' '}
        <TextLink onClick={() => {
          window.open('https://nekst.com/privacy', '_blank');
        }}>Privacy Policy</TextLink>
        {' '}
        to understand how your data is handled and protected.
      </Text>
    </>
  )
}

export default function CalendarIntegrationPage() {

  const eventConfigurationService = useEventsConfigurationService();

  const { data: configuration } = useDataLoaderNew(
    eventConfigurationService.getConfiguration,
    {
      events: [EVENT_CONFIGURATION_DELETED]
    }
  );

  const code = new URLSearchParams(window.location.search).get('errorCode');

  return (
    <ToggleWrapper feature={ToggledFeature.EVENT_TASKS}>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Calendar Integration" />
      </SettingsBreadcrumbs>
      <InnerBlock title="Calendar Integration">
        {code && <ErrorCodeMessage code={code as EventConfigurationErrorCode} />}
        {!configuration && <AuthenticationLink />}
        {configuration && !configuration.isValid && (
          <ErrorMessage>
            Your Google account connection is no longer valid. Please sign in again to continue.
          </ErrorMessage>
        )}
        {configuration && (<CalendarConfigurationWidget configuration={configuration} />)}
        <PolicyLink />
      </InnerBlock>
    </ToggleWrapper>
  );
}
